import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from './sharedService';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};
const PREFIX = 'company-representative'
@Injectable({
  providedIn: 'root'
})
export class CompanyRepresentativeService extends BaseService {

  constructor(public http: HttpClient, public sharedService: SharedService) {
    super(http, sharedService);
  }

  matchRequest(compRep) {
    return this.http.post<any>(this.sharedService.apiUrl('company-representative/matchrequest'), compRep, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  rejectRequest(compRep) {
    return this.http.post<any>(this.sharedService.apiUrl('company-representative/rejectrequest'), compRep, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  setSmsStatus(company) {
    return this.http.post<any>(this.sharedService.apiUrl('company-representative/smsstatus'), {tin:company.tin, smsstatus: company.sendSms}, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }


  getUnmatchedRequestsCount(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('company-representative/unmatchedrequestcount')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getUsernames(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('company-representative/list')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getMatchRequest(id): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('company-representative/matchrequest/') + id).pipe(
      map(res => {
        return res;
      })
    );
  }

  getCurrentUser(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('company-representative/current')).pipe(
      map(res => {
        return res;
      })
    );
  }


  getCompanyData(tin: any): Observable<any> {
    let params = new HttpParams().set('tin', tin);
    const httpOptions = { params };
    let companyData$ = this.http.get<any>(this.sharedService.apiUrl(PREFIX+'/companyData'), httpOptions).pipe(
      map((res: Response) => { return res }), catchError(this.handleError<any>('company data'))
    )
    return companyData$;
  }


}



